var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 45.629 33.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_35550",
    "data-name": "Path 35550",
    d: "M59.469,110h-3.26V89.831a.561.561,0,0,0-.561-.561H49.4a.561.561,0,0,0-.561.561V110H46.2V97.762a.561.561,0,0,0-.561-.561H39.391a.561.561,0,0,0-.561.561V110H36.2V93.352a.561.561,0,0,0-.561-.561H29.386a.561.561,0,0,0-.561.561V110H26.195v-9.673a.561.561,0,0,0-.561-.561H19.381a.561.561,0,0,0-.561.561V110h-3.26a.561.561,0,0,0,0,1.121H59.469a.561.561,0,1,0,0-1.121ZM49.956,90.391h5.132V110H49.956Zm-10,7.932h5.132V110H39.951Zm-10-4.41h5.132V110H29.947Zm-10,6.974h5.132V110H19.942Zm2.565-4.527A3.04,3.04,0,0,0,25.1,91.726l5.576-5.052a3.035,3.035,0,0,0,4.11-.4l4.882,2.934a3.042,3.042,0,1,0,5.413-.577l5.648-5.3a3.05,3.05,0,1,0-.767-.817l-5.648,5.3a3.036,3.036,0,0,0-4.067.434l-4.882-2.934a3.042,3.042,0,1,0-5.443.532L24.345,90.9a3.041,3.041,0,1,0-1.838,5.463ZM52.522,78.951A1.921,1.921,0,1,1,50.6,80.872,1.923,1.923,0,0,1,52.522,78.951Zm-10,9.394A1.921,1.921,0,1,1,40.6,90.265,1.923,1.923,0,0,1,42.517,88.345ZM32.512,82.332a1.921,1.921,0,1,1-1.921,1.921A1.923,1.923,0,0,1,32.512,82.332Zm-10,9.065a1.921,1.921,0,1,1-1.921,1.921A1.923,1.923,0,0,1,22.507,91.4Z",
    transform: "translate(-14.7 -77.53)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsInsights);
export default __webpack_public_path__ + "static/media/reportsInsights.5fff6e02af29687d58c7e8a29a20f0bb.svg";
export { ForwardRef as ReactComponent };